import { render, staticRenderFns } from "./protocolTwo.vue?vue&type=template&id=06f45c75&"
var script = {}
import style0 from "./protocolTwo.vue?vue&type=style&index=0&id=06f45c75&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports